var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":""}},[_c('v-main',[_c('router-view'),_c('msp-annuncio-ui'),(_vm.isAtleta)?_c('msp-richiesta-abbinamento'):_vm._e(),(_vm.isAtleta)?_c('msp-ricollega-garmin'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }